/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleExpand = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 26 26">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12ZM24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12Z"
        fill="#21295C"
      />
      <path
        d="M5.30816 9.30592C5.50554 9.11004 5.7732 9 6.05229 9C6.33138 9 6.59904 9.11004 6.79641 9.30592L12.0064 14.4779L17.2163 9.30592C17.4148 9.11559 17.6807 9.01027 17.9566 9.01266C18.2326 9.01504 18.4966 9.12492 18.6917 9.31865C18.8869 9.51237 18.9976 9.77443 19 10.0484C19.0024 10.3223 18.8963 10.5863 18.7045 10.7833L12.7505 16.6941C12.5531 16.89 12.2854 17 12.0064 17C11.7273 17 11.4596 16.89 11.2622 16.6941L5.30816 10.7833C5.11085 10.5874 5 10.3217 5 10.0446C5 9.76757 5.11085 9.50186 5.30816 9.30592Z"
        fill="#21295C"
      />
    </BaseSvgIcon>
  )
}

export default CircleExpand
